// Generates a JPEG thumbnail and reads image dimensions in the browser before
// uploading, so we never send full-size data just to build a preview.

export interface PreparedImage {
  width: number;
  height: number;
  thumbBlob: Blob;
}

const MAX_THUMB = 512;

export async function prepareImage(file: File): Promise<PreparedImage> {
  const bitmap = await createImageBitmap(file);
  const { width, height } = bitmap;

  const scale = Math.min(1, MAX_THUMB / Math.max(width, height));
  const tw = Math.max(1, Math.round(width * scale));
  const th = Math.max(1, Math.round(height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = tw;
  canvas.height = th;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D not available');
  ctx.drawImage(bitmap, 0, 0, tw, th);
  bitmap.close();

  const thumbBlob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Thumbnail failed'))),
      'image/jpeg',
      0.8,
    ),
  );

  return { width, height, thumbBlob };
}
